<template>
  <base-dialog
    :visible="visible"
    :show-close="false"
    :class="['detail-dialog', { 'no-bar': fullScreen }]"
    border-radius="none"
    @open="open"
    @closed="close"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">
          <span class="title-wrap">
            <span class="favorite">
              <el-tooltip
                effect="dark"
                :content="sheetData.favoriteId ? '取消收藏' : '收藏'"
                placement="top"
              >
                <span @click="dealFavorite" class="pointer" style="margin: 0 4px">
                  <svg-icon
                    :icon-class="
                      sheetData.favoriteId ? 'star_add-favorite' : 'star_not-add-favorite'
                    "
                  ></svg-icon>
                </span>
              </el-tooltip>
            </span>
            <span class="title-info">
              <span v-tip>{{ title }}</span>
            </span>
            <span class="operation">
              <el-tooltip effect="dark" content="复制记录ID" placement="top">
                <span @click="copyDataId" class="pointer" style="margin: 0 4px">
                  <svg-icon icon-class="detail_copy-id"></svg-icon>
                </span>
              </el-tooltip>
              <template v-if="tableDataIds">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="bottom"
                  :disabled="dataOrder === 'first'"
                >
                  <div slot="content">
                    上一条
                    <br />
                    快捷键(Alt ＋ ←)
                  </div>
                  <i
                    class="el-icon-arrow-left icon-trun-page"
                    :class="{ 'is-disabled': dataOrder == 'first' }"
                    @click="openData('previous')"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="bottom"
                  :disabled="dataOrder === 'last' || tableDataIds.length == 1"
                >
                  <div slot="content">
                    下一条
                    <br />
                    快捷键(Alt ＋ →)
                  </div>
                  <i
                    class="el-icon-arrow-right icon-trun-page"
                    :class="{ 'is-disabled': dataOrder == 'last' || tableDataIds.length == 1 }"
                    @click="openData('later')"
                  ></i>
                </el-tooltip>
              </template>
            </span>
          </span>
        </div>
        <div class="button-warp">
          <base-button
            v-if="sheetDef.sheetId === '5dea2a03051d09045b25d10a'"
            size="normal"
            @click="exportDeliverDetail"
          >
            发货详情导出
          </base-button>
          <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
            v-for="(btn, index) in btnMenuList.slice(0, 3)"
            :key="index"
            :content="btn.desc"
            :disabled="!btn.hasOwnProperty('desc') || _.isEmpty(btn.desc)"
          >
            <base-button
              size="normal"
              @click="clickBtn(btn.command)"
              :style="
                btn.bgColor === '#fff'
                  ? 'background:' + btn.bgColor
                  : 'border:none;background:' + btn.bgColor
              "
            >
              <svg-icon :style="'color:' + btn.textColor" :icon-class="btn.icon"></svg-icon>
              <span :style="'color:' + btn.textColor">
                {{ btn.title }}
              </span>
            </base-button>
          </el-tooltip>
          <dropdown-menu
            v-if="btnMenuList.length > 3"
            @click="clickBtn"
            :menu-list="btnMenuList.slice(3)"
            placement="bottom-end"
            from="detailDialog"
          >
            <base-button size="normal" style="width: 32px; padding: 0">
              <i class="el-icon-more"></i>
            </base-button>
          </dropdown-menu>
        </div>
        <div class="operation-wrap">
          <span class="svg-icon" @click="init">
            <svg-icon icon-class="refresh" :class="rotate ? ' go' : ''"></svg-icon>
          </span>
          <span class="svg-icon" @click="close">
            <svg-icon icon-class="close"></svg-icon>
          </span>
        </div>
      </div>
    </template>
    <div class="body-wrap">
      <verify-row
        ref="verifyRow"
        v-show="sheetData.verifying"
        :sheet-def="sheetDef"
        @task-verified="sheetVerified"
      ></verify-row>
      <div class="sheet-info">
        <div class="data-info">
          <overview-info
            :overview-fields="overviewFields"
            :sheet-data="sheetData"
            from="sheetFront"
          ></overview-info>
          <progress-info
            :progress="progress"
            :control-map="controlsMap"
            :sheetData="sheetData"
            from="sheetFront"
            ref="progressInfo"
          ></progress-info>
          <div class="content-wrap">
            <div class="side-nav-wrap">
              <sheet-menu
                ref="sideMenu"
                :menu-list="tabs"
                @select="selectMenu"
                :active="curTab.name"
                class="sheet-menu"
              ></sheet-menu>
            </div>
            <div class="content-box">
              <el-radio-group
                v-if="curTab.name === '详细信息'"
                v-model="widthLevel"
                class="radio-group"
                @change="widthLevelChange"
              >
                <el-tooltip class="item" effect="dark" content="两列布局" placement="bottom">
                  <el-radio-button label="1">
                    <svg-icon
                      icon-class="detail_two-column"
                      :style="widthLevel === '1' ? 'color:#1989fa' : 'color:#C0C4CC'"
                      class="radio-icon"
                    ></svg-icon>
                  </el-radio-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="自适应布局" placement="bottom">
                  <el-radio-button label="2">
                    <svg-icon
                      :icon-class="widthLevel == '2' ? 'svgo_loose' : 'svgo_loose-gray'"
                      class="radio-icon"
                    ></svg-icon>
                  </el-radio-button>
                </el-tooltip>
              </el-radio-group>
              <div
                class="content-body"
                v-ps
                :style="{ overflow: curTab.cid || curTab.name == '变更记录' ? 'hidden' : 'unset' }"
              >
                <template v-if="curTab.name === '详细信息'">
                  <data-detail
                    ref="dataDetail"
                    :width-level="widthLevel"
                    :sheet-def="sheetDef"
                    :sheet-data="sheetData"
                  ></data-detail>
                </template>
                <template v-else-if="curTab.type === 'ref'">
                  <div class="sheet-table-wrap" :class="{ 'full-screen': fullScreen }">
                    <div class="operation">
                      <div style="display: flex">
                        <div v-if="fullScreen" class="sheet-name font-topic">{{ curTab.name }}</div>
                        <field-search
                          ref="fieldSearch"
                          :controls="refSearchControls"
                          @search="refSearchData"
                        ></field-search>
                      </div>
                      <div class="ref-button-group">
                        <span
                          v-if="!curTab.related && canEdit"
                          @click="refDataDialogVisible = true"
                        >
                          +关联记录
                        </span>
                        <span @click="excelTemplateDialogVisible = true">
                          导出
                        </span>
                        <span @click="printRef">
                          打印
                        </span>
                        <span @click="fullScreen = !fullScreen">
                          {{ fullScreen ? "退出全屏" : "全屏" }}
                        </span>
                      </div>
                    </div>
                    <ref-sheet-table
                      :data-ids="curTab.dataIds"
                      :ref-control="controlsMap[refCondition.refControlId]"
                      :conditions="[refTableFilters]"
                      @delete-click="updateRef($event, curTab.cid, false)"
                      :delete-visible="canEdit"
                      :col-filter="false"
                    ></ref-sheet-table>
                  </div>
                </template>
                <template v-else>
                  <div :key="curTab.cid">
                    <div class="chart-wrapper" :style="curTab.height">
                      <full-board-title
                        :figure="figure"
                        @setFilter="setFilter('current')"
                        :filter-visible="filterVisible"
                      ></full-board-title>
                      <div class="setting" :class="'board-theme-' + board.theme">
                        {{ figure.name }}
                        <span style="float: right;" class="more-setting">
                          <div class="wrapper">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              content="刷新"
                              placement="bottom"
                            >
                              <svg-icon
                                class="refresh"
                                :class="active ? 'button-active' : ''"
                                icon-class="refresh"
                                @click.native="refreshChart"
                              ></svg-icon>
                            </el-tooltip>
                            <el-tooltip
                              class="item"
                              effect="dark"
                              content="全屏"
                              placement="bottom"
                            >
                              <svg-icon
                                icon-class="board_full"
                                class="full"
                                @click.native="fullChart"
                              ></svg-icon>
                            </el-tooltip>
                            <dropdown-menu
                              v-if="exportOptions.length"
                              :menu-list="exportOptions"
                              @click="handleCommand"
                              placement="bottom-end"
                            >
                              <span class="pointer">
                                <svg-icon icon-class="board_more" class="pointer"></svg-icon>
                              </span>
                            </dropdown-menu>
                          </div>
                        </span>
                      </div>
                      <chart-item
                        :chart="figure"
                        :boardId="board.id"
                        :theme="board.theme"
                        :app-id="board.appId"
                        hideHeader
                        ref="image"
                        class="image"
                        id="image"
                        :class="'board-theme-' + board.theme"
                        :data-id="dataId"
                      ></chart-item>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="member" :style="fold ? 'width:64px' : 'width:320px'">
          <el-tooltip v-if="fold" effect="dark" content="展开" placement="bottom" key="1">
            <span @click="foldMemberInfo" class="fold">
              <svg-icon icon-class="detail_open" style="font-size: 40px;"></svg-icon>
            </span>
          </el-tooltip>
          <el-tooltip v-else effect="dark" content="收起" placement="bottom" key="2">
            <span @click="foldMemberInfo" class="fold">
              <svg-icon icon-class="detail_fold" style="font-size: 40px;"></svg-icon>
            </span>
          </el-tooltip>
          <member-info
            ref="memberInfo"
            :fold="fold"
            :data-id="dataId"
            :app-id="appId"
            :sheet-data="sheetData"
            @changeFold="foldMemberInfo"
            @setKeydown="setKeydown"
            :sheet-def="sheetDef"
          ></member-info>
        </div>
      </div>
    </div>
    <!--选择打印模板 -->
    <select-print-template
      @dealLast="dealLast"
      ref="selectPrintTemplateDialog"
    ></select-print-template>
    <!--编辑数据-->
    <edit-dialog
      ref="editDialog"
      :from="editDialogType"
      :sheet-id="sheetData.sheetId"
      :data-id="dataId"
      :init-data="copyData"
      @after-submit="dataSubmitted"
    ></edit-dialog>
    <!--按钮填写-->
    <fill-dialog
      ref="fillDialog"
      from="fillForm"
      :sheet-id="btnSheetId"
      :data-id="btnDataId"
      :btn-source-data-id="dataId"
      :btn-source-app-id="appId"
      :btn-info="activeCustomBtn"
      @after-submit="dataSubmitted"
    ></fill-dialog>
    <!--按钮关联新建-->
    <edit-dialog
      ref="btnEditDialog"
      from="reference"
      :sheet-id="btnSheetId"
      :data-id="btnDataId"
      :refDataInfo="{
        _ccid: btnCcid,
        data: btnSheetData
      }"
      @after-submit="dataSubmitted"
    ></edit-dialog>
    <!--新增关联多条-->
    <ref-data-dialog
      multiple
      :control="curControl"
      :ref-sheet="refSheetDef"
      :ref-condition="refCondition"
      :ref-sheet-data="sheetData"
      :data-ids="curTab.dataIds"
      :dialog-visible.sync="refDataDialogVisible"
      @select="refDataSelected"
      @data-created="dataSubmitted"
      @submit="addRefData"
    ></ref-data-dialog>
    <!--选择导出Excel模板(关联多条)-->
    <select-excel-tpl
      :sheet-id="sheetData.sheetId"
      :ref-sheet-id="curTab.type === 'ref' ? curControl.refSheetId : ''"
      :visible.sync="excelTemplateDialogVisible"
      @submit="excelTemplateSelected"
      :app-id="appId"
    ></select-excel-tpl>
    <!--选择同步信息 -->
    <sync-data-dialog
      ref="syncDataDialog"
      :sheet-id="sheetData.sheetId"
      :selection="selection"
      :app-id="appId"
    ></sync-data-dialog>
    <!--设置关联项目-->
    <set-related-project-dialog
      ref="setRelatedProjectDialog"
      @change="relatedProjectChanged"
      :sheet-data-id="dataId"
      :sheet-id="sheetDef.sheetId"
      :project-id="sheetData.projectId"
    ></set-related-project-dialog>
    <favorite-dialog ref="favoriteInfo" from="sheetDetail"></favorite-dialog>
    <confirm-dialog ref="confirm" :from="from" @nextBatch="nextBatch"></confirm-dialog>
    <full-chart-dialog
      ref="fullChart"
      :data-id="dataId"
      :filter-visible="filterVisible"
      @setFilter="setFilter('full')"
    ></full-chart-dialog>
    <chart-filter
      ref="chartFilter"
      @submit="submitChartFilter"
      :dialog-visible.sync="chartFilterVisible"
      :search-sheet="{ sheetId: figureSheet.sheetId, controls: figureSheet.controls }"
      :condition-list="conditionList"
      :pre-condition-list="preConditionList"
      :rely-sheet-info="sheetDef"
      @close="closeChartFilter"
      from="chart_control"
    ></chart-filter>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import RefDataDialog from "@/components/Sheet/RefDataDialog"
import FavoriteDialog from "@/components/Sheet/DetailDialog/FavoriteDialog"
import { getSheetDataForDetail, updateRefData } from "@/api/sheet/sheetData"
import {
  getAvailableSheets,
  getSheet,
  getSheetDefForDetail,
  getSheetDefForEdit
} from "@/api/sheet/sheet"
import { beforeSubmit, decorateSheet } from "@/utils/sheet"
import { saveFavorite, deleteFavorite } from "@/api/user"
import OverviewInfo from "@/views/Backend/AdminEdit/Sheet/Field/fields-content/overview-info"
import BaseButton from "@/components/UIComponents/Button"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import SelectPrintTemplate from "./SelectPrintTemplate"
import EditDialog from "@/components/Sheet/EditDialog"
import FillDialog from "@/components/Sheet/FillDialog"
import { getSheetInAvailableSheets } from "@/utils/sheet"
import DataDetail from "./DataDetail"
import SelectExcelTpl from "@/components/UIComponents/SelectExcelTpl"
import SheetMenu from "../SideNav/SheetMenu"
import { loadingService } from "@/utils/ui"
import { exportByExcelTemplate } from "@/api/sheet/sheetView"
import SetRelatedProjectDialog from "./SetRelatedProjectDialog"
import VerifyRow from "./VerifyRow"
import { copyToClipBoard, deepClone, downloadBlob } from "@/utils/common"
import RefSheetTable from "@/components/UIComponents/SheetTable/RefSheetTable"
import { setFrontSetting, getFrontSetting } from "@/api/user"
import MemberInfo from "@/components/Sheet/DetailDialog/MemberInfo"
import BtnMixin from "@/components/UIComponents/BtnMixin"
import ProgressInfo from "@/views/Backend/AdminEdit/Sheet/Field/fields-content/progress-info"
import FieldSearch from "@/components/Sheet/FieldSearch"
import ConfirmDialog from "@/views/Front/Sheet/View/ConfirmDialog"
import SyncDataDialog from "@/views/Front/Sheet/View/SyncDataDialog"
import { getDashboard } from "@/api/appManage/statistics"
import ChartItem from "@/views/Backend/Admin/Statistics/chartEdit/ChartItem"
import FullMixin from "@/views/Backend/Admin/Statistics/FullMixin"
import FullChartDialog from "@/components/Sheet/DetailDialog/FullChartDialog"
import ExportChart from "@/views/Backend/Admin/Layout/mixin/ExportChart"
import FullBoardTitle from "@/views/Backend/Admin/Statistics/FullBoardTitle"
import ChartFilter from "@/components/UIComponents/ChartFilter"
import { chartList } from "@/views/Backend/Admin/Statistics/chartEdit/static"
import dj from "dayjs"

export default {
  name: "DetailDialog",
  components: {
    ChartFilter,
    FullBoardTitle,
    FullChartDialog,
    ChartItem,
    SyncDataDialog,
    ConfirmDialog,
    FieldSearch,
    ProgressInfo,
    MemberInfo,
    RefSheetTable,
    BaseDialog,
    BaseButton,
    OverviewInfo,
    DropdownMenu,
    SelectPrintTemplate,
    EditDialog,
    FillDialog,
    RefDataDialog,
    SelectExcelTpl,
    DataDetail,
    SheetMenu,
    SetRelatedProjectDialog,
    VerifyRow,
    FavoriteDialog
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    appId: {
      type: String,
      required: true
    },
    visible: Boolean,
    tableDataIds: Array, // 外部工作表当前页的 id 列表，用于切换上/下一条
    sheetDataBak: Object, // 回收站详细信息
    isBak: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return { dataInfo: this.dataInfo, detailDialog: this }
  },
  data() {
    return {
      chartList,
      sheetData: {},
      sheetDef: {},
      refDataDialogVisible: false,
      excelTemplateDialogVisible: false,
      curTab: { name: "详细信息" },
      // 按钮相关
      btnSheetDefs: {},
      btnSheetId: "",
      btnDataId: "",
      btnCcid: "",
      btnSheetData: {},
      activeCustomBtn: {}, // 当前点击的自定义btn
      availableSheets: [],
      count: 0,
      fullScreen: false, // 关联多条全屏
      editDialogType: "edit",
      copyData: null,
      dataInfo: { dataId: "", appId: "" },
      rotate: false,
      widthLevel: "1",
      fold: true,
      refTableFilters: [],
      from: "print",
      pageInfo: {
        page: 1,
        size: 200
      },
      selection: {
        command: "本页",
        length: 1,
        tableData: []
      },
      board: {},
      figure: {},
      active: false,
      chartFilterVisible: false,
      conditionList: [],
      preConditionList: [],
      figureSheet: {},
      chartFrom: "current"
    }
  },
  mixins: [BtnMixin, FullMixin, ExportChart],
  computed: {
    filterVisible() {
      return !(this._.isEmpty(this.conditionList) && this._.isEmpty(this.preConditionList))
    },
    title() {
      if (!this.sheetDef.name) return "加载中..."
      if (this.sheetData.title === "数据不存在") return "数据不存在"
      return `[${this.sheetDef.name}] ${this.sheetData.title}`
    },
    dataOrder() {
      if (!this.tableDataIds) return ""
      let index = this.tableDataIds.indexOf(this.dataId)
      if (index == 0) return "first"
      else if (index == this.tableDataIds.length - 1) return "last"
      return ""
    },
    controlsMap() {
      let controls = this.sheetDef.controls || []
      return this._.keyBy(controls, "_cid")
    },
    overviewFields() {
      return (this.sheetDef.layout?.summary || []).map(cid => this.controlsMap[cid])
    },
    progress() {
      let result = {}
      result.stepCid = this.sheetDef.layout?.stepCid || ""
      result.stepList = this.sheetDef.layout?.stepList || []
      return result
    },
    tabs() {
      let refMultiTabs =
        this.sheetDef.controls
          ?.filter(c => c.display && c._type === "ref" && !c.oneFlag)
          .map(c => {
            let dataIds = this.sheetData.data[c._cid] || []
            return {
              name: `${c.name}（${dataIds.length}）`,
              sheetId: c.refSheetId,
              dataIds,
              cid: c._cid,
              related: c.related,
              type: c._type
            }
          }) || []
      let chartTabs =
        this.sheetDef.controls
          ?.filter(c => c.display && c._type === "chart")
          .map(c => ({
            name: c.name,
            cid: c._cid,
            boardId: c.dashboardId,
            chartId: c.chartId,
            type: c._type,
            height: "height:" + c.height + "px !important",
            filters: c.filters
          })) || []
      return [{ name: "详细信息" }, ...refMultiTabs, ...chartTabs]
    },
    btnMap() {
      return this._.keyBy(this.sheetDef.btnList, "id")
    },
    btnList() {
      return this.sheetDef.btnList || []
    },
    btnMenuList() {
      return this.btnList.map(btn => {
        if (btn.id.length === 24) {
          return {
            title: btn.name,
            command: btn.id,
            desc: btn.desc,
            icon: btn.icon ? "button_" + btn.icon : "button_icon-01",
            bgColor: btn.color && btn.color !== "#f5f7fa" ? btn.color : "#fff",
            textColor: btn.color && btn.color !== "#f5f7fa" ? "#fff" : "#1989fa",
            iconColor: btn.color && btn.color !== "#f5f7fa" ? btn.color : "#313132"
          }
        } else {
          return {
            title: btn.name,
            command: btn.id,
            icon: "basic-button_" + btn.id,
            bgColor: "#fff",
            textColor: "#1989fa",
            iconColor: "#313132"
          }
        }
      })
    },
    canEdit() {
      return this.btnMenuList.map(btn => btn.command).includes("edit")
    },
    curControl() {
      return this.controlsMap?.[this.curTab.cid] || {}
    },
    // 上传至服务器的 form 格式
    sheetDataServer() {
      if (!this.sheetData) return {}
      let sheetDataServer = this._.cloneDeep(this.sheetData)
      sheetDataServer.data = beforeSubmit({
        form: this.sheetData.data,
        fieldsMap: this.controlsMap,
        skipRelatedControl: false
      })
      return sheetDataServer
    },
    refCondition() {
      return {
        refSheetId: this.sheetData.sheetId,
        refControlId: this.curControl._cid,
        refSheetData: this.sheetDataServer
      }
    },
    refSheetDef() {
      return getSheetInAvailableSheets(this.availableSheets, this.curControl.refSheetId)
    },
    refSearchControls() {
      return decorateSheet(this.refSheetDef)?.controls
    }
  },
  watch: {
    "figure.type": function() {
      this.$nextTick(() => this.$refs.image.init(this.figure))
    }
  },
  created() {
    this.$on("refresh", t => {
      setTimeout(() => this.init(), 1000)
    })
  },
  methods: {
    init() {
      this.rotate = !this.rotate
      setTimeout(() => {
        this.rotate = !this.rotate
      }, 1000)
      const loading = this.$loading({ target: this.$el.children[0] })
      Promise.all([
        this.getAvailableSheets(),
        this.refreshData(),
        this.getFrontSetting(),
        this.getDiscussSetting()
      ])
        .then(() => {
          this.$nextTick(() => this.$refs.sideMenu.init())
          this.getBtnSheetDefs()
          this.$refs.memberInfo.init()
        })
        .finally(() => loading.close())
    },
    initDataDetail() {
      let component = this.$refs.dataDetail
      component && component.init()
    },
    selectMenu(menu) {
      const { cid } = menu
      this.curTab = this.tabs.find(tab => tab.cid == cid) || { name: "详细信息" }
      if (menu.name == "详细信息") this.$nextTick(() => this.initDataDetail())
      else if (this.curTab.type === "ref")
        this.$nextTick(() => {
          this.$refs.fieldSearch.reset()
          this.refTableFilters = []
        })
      else {
        this.conditionList = []
        this.preConditionList = []
        getDashboard(this.curTab.boardId).then(res => {
          this.board = res
          this.figure = this.board.charts.find(chart => chart.chartId === this.curTab.chartId)
          this.figure.controlFilters = this.curTab.filters
          this.preConditionList = this.figure.controlFilters
          this.conditionList = this.figure.filters
          this.setChartDisabled()
          getSheet(this.figure.sheetId).then(res => {
            this.figureSheet = res
            this.figure.dataSource = this.figureSheet.name
          })
          this.figure.syncTime = dj(new Date()).format("YYYY-MM-DD HH:mm:ss")
          this.$nextTick(() => this.$refs.image.init(this.figure))
        })
      }
    },
    async dataSubmitted(data, from) {
      this.$emit("data-changed")
      if (from === "edit") {
        this.close()
      } else if (from === "copy") {
        return
      } else if (from === "reference") {
        let sheetData = this.btnSheetData
        let sheetDef = {}
        if (this.activeCustomBtn.refCid) sheetDef = this.btnSheetDefs[this.activeCustomBtn.refCid]
        else sheetDef = this.sheetDef
        await this.editReference(data, sheetData, sheetDef)
        this.init()
        this.$emit("data-changed")
      } else if (from === "addRefData") {
        // 新建并关联
        if (this.curControl.twoWay) {
          this.init()
        } else {
          this.addRefData([data])
        }
      } else {
        this.init()
      }
    },
    sheetVerified() {
      this.refreshData()
      this.$emit("data-changed")
    },
    refreshData() {
      Object.assign(this.dataInfo, { dataId: this.dataId, appId: this.appId })
      return this.getSheetData()
    },
    getFrontSetting() {
      return getFrontSetting(this.dataId).then(res => {
        if (res?.widthLevel) this.widthLevel = res.widthLevel.level
      })
    },
    getDiscussSetting() {
      return getFrontSetting(this.appId).then(res => {
        if (res?.discuss) this.fold = res.discuss.fold
        else this.fold = false
      })
    },
    getSheetData() {
      if (this.isBak) {
        this.sheetData = this.sheetDataBak
        this.$refs.verifyRow?.init(this.sheetDataBak)
        return getSheetDefForEdit(this.sheetDataBak.sheetId).then(sheetDef => {
          this.sheetDef = decorateSheet(sheetDef)
          this.selectMenu(this.curTab)
        })
      }
      return getSheetDataForDetail({ dataId: this.dataId, appId: this.appId })
        .then(sheetData => {
          this.sheetData = sheetData
          this.$refs.verifyRow?.init(sheetData)
          return getSheetDefForDetail(sheetData.sheetId, this.dataId).then(sheetDef => {
            this.sheetDef = decorateSheet(sheetDef)
            this.selectMenu(this.curTab)
          })
        })
        .catch(() => {
          this.sheetData = { title: "数据不存在" }
          this.sheetDef = { name: "数据不存在" }
        })
    },
    getBtnSheetDefs() {
      this.btnList.forEach(x => {
        if (x.refCid) {
          let sheetData = this.sheetData.data[x.refCid]
          if (sheetData && sheetData.length > 0) {
            getSheetDefForDetail(sheetData[0].sheetId, sheetData[0].id).then(sheetDef => {
              this.$set(this.btnSheetDefs, x.refCid, sheetDef)
            })
          }
        }
      })
    },
    setKeydown() {
      document.onkeydown = e => {
        let keyCode = e.keyCode || e.which || e.charCode
        let altKey = e.altKey
        if (altKey && keyCode === 37) {
          this.openData("previous")
        } else if (altKey && keyCode === 39) {
          this.openData("later")
        }
      }
    },
    open() {
      this.setKeydown()
      this.init()
      this.$nextTick(() => this.$refs.sideMenu.init())
    },
    close() {
      document.onkeydown = undefined
      this.$refs.memberInfo?.$refs.dataDiscuss?.changeVisible()
      this.curTab = { name: "详细信息" }
      this.$emit("update:visible", false)
    },
    openData(direction) {
      let dataId = ""
      let index = this.tableDataIds.indexOf(this.dataId)
      if (direction == "previous") {
        if (this.dataOrder !== "first") {
          dataId = this.tableDataIds[index - 1]
        } else {
          this.$message.info("已经是第一条数据")
        }
      } else if (direction == "later") {
        if (this.dataOrder !== "last") {
          dataId = this.tableDataIds[index + 1]
        } else {
          this.$message.info("已经是最后一条数据")
        }
      }
      if (!dataId) return
      this.$emit("trun-page", dataId)
    },
    async clickBtn(btnId) {
      switch (btnId) {
        case "edit":
          this.editDialogType = "edit"
          this.$refs.editDialog.open()
          break
        case "delete":
          await this.deleteSheetData(this.dataId, this.appId)
          this.$emit("data-changed")
          this.close()
          break
        case "lock":
        case "unlock":
          await this.lockOrUnlockData(this.sheetData)
          this.init()
          this.$emit("data-changed")
          break
        case "print":
          this.$refs.selectPrintTemplateDialog.open({
            dataId: this.dataId,
            sheetId: this.sheetData.sheetId,
            appId: this.appId
          })
          break
        case "copy":
          this.editDialogType = "copy"
          this.handleDetailCopyData()
          break
        case "sync":
          this.selection.tableData = [this.sheetData]
          this.$refs.syncDataDialog.open()
          break
        case "project":
          this.$refs.setRelatedProjectDialog.open()
          break
      }
      let btn = this.btnMap[btnId]
      this.activeCustomBtn = btn
      switch (btn.actionType) {
        case "DIRECT": {
          const loadingInstance = loadingService()
          // try中有异常抛出，也是会去执行finally
          try {
            await this.customBtnRequest(this.appId, this.dataId, btn.id, this.sheetData.sheetId)
            this.refreshData()
            this.$emit("data-changed")
          } finally {
            loadingInstance.close()
          }
          break
        }
        case "CONFIRM": {
          const loadingInstance = loadingService()
          this.$confirm(btn.confirmMsg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              await this.customBtnRequest(this.appId, this.dataId, btn.id, this.sheetData.sheetId)
              this.refreshData()
              this.$emit("data-changed")
            })
            .finally(() => loadingInstance.close())
          break
        }
        case "FILL": {
          if (btn.refCid) {
            let sheetData = this.sheetData.data[btn.refCid]
            if (!sheetData || sheetData.length == 0) {
              this.$message.error("当前无关联数据")
              return
            }
            if (!this.btnSheetDefs[btn.refCid].controls.some(x => x._cid == btn.fillCids[0].cid)) {
              this.$message.error("自定义按钮配置有误")
            }
            sheetData = sheetData[0]
            if (btn.fillType == "CREATE_REF") {
              let btnSheet = this.btnSheetDefs[btn.refCid].controls.find(
                x => x._cid == btn.fillCids[0].cid
              )
              if (btnSheet.oneFlag && sheetData.data[btn.fillCids[0].cid]?.length == 1) {
                this.$message.error("当前已存在关联数据")
                return
              }
              this.btnSheetData = deepClone(sheetData)
              this.btnSheetId = btnSheet.refSheetId
              this.btnCcid = btnSheet._ccid
              this.btnDataId = ""
              this.$refs.btnEditDialog.open()
            } else {
              this.btnSheetId = sheetData.sheetId
              this.btnDataId = sheetData.id
              this.$refs.fillDialog.open()
            }
          } else {
            let btnSheet = this.sheetDef.controls.find(x => x._cid == btn.fillCids[0].cid)
            if (btn.fillType == "CREATE_REF") {
              if (!this.sheetDef.controls.some(x => x._cid == btn.fillCids[0].cid)) {
                this.$message.error("自定义按钮配置有误")
              }
              if (btnSheet.oneFlag && this.sheetData.data[btn.fillCids[0].cid]?.length == 1) {
                this.$message.error("当前已存在关联数据")
                return
              }
              this.btnSheetData = deepClone(this.sheetData)
              this.btnSheetId = btnSheet.refSheetId
              this.btnCcid = btnSheet._ccid
              this.btnDataId = ""
              this.$refs.btnEditDialog.open()
            } else {
              this.btnSheetId = this.sheetData.sheetId
              this.btnDataId = this.dataId
              this.$refs.fillDialog.open()
            }
          }
          break
        }
      }
    },
    // 复制当前数据
    handleDetailCopyData() {
      let data = {}
      for (const key in this.sheetData.data) {
        let control = this.controlsMap[key]
        if (control._type == "ref" && (!control.oneFlag || control.related)) continue
        if (control._type == "sn") continue
        data[key] = this.sheetData.data[key]
      }
      data = this._.cloneDeep(data)
      this.copyData = data
      this.$refs.editDialog.open()
    },
    // 更新关联多条数据关联关系
    updateRef(refDataList, cid, addFlag) {
      if (!Array.isArray(refDataList)) refDataList = [refDataList]
      updateRefData({
        type: addFlag ? "add" : "delete",
        appId: this.appId,
        dataId: this.dataId,
        refCid: cid,
        refDataIds: refDataList.map(row => row.id).join(",")
      }).then(() => this.init())
    },
    getAvailableSheets() {
      return getAvailableSheets({ appId: this.appId }).then(availableSheets => {
        this.availableSheets = availableSheets
      })
    },
    refDataSelected(selected) {
      this.addRefData([selected])
    },
    addRefData(valList = []) {
      this.updateRef(valList, this.curControl._cid, true)
    },
    excelTemplateSelected(excelTemplate) {
      let loadingInstance = loadingService({ text: "请求中" })
      // 导出当前表已关联数据
      let control = this.curControl
      let dataIds = this.sheetData?.data?.[control._cid]
      exportByExcelTemplate({
        sheetId: control.refSheetId,
        templateId: excelTemplate.id === "default" ? null : excelTemplate.id,
        dataIds
      })
        .then(() => this.$message.success("导出任务已提交"))
        .finally(() => loadingInstance.close())
    },
    // 导出发货详情
    exportDeliverDetail() {
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在导出发货详情...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      import('@/utils/http').then(({ default: request }) => {
        request.get(`/sheet/export/delivery/${this.dataId}`, {
          params: { appId: this.appId },
          responseType: 'blob'
        }).then(response => {
          // 从响应头中获取文件名
          const contentDisposition = response.headers['content-disposition']
          let filename = `发货详情_${new Date().getTime()}.xlsx`
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (filenameMatch && filenameMatch[1]) {
              filename = decodeURIComponent(filenameMatch[1].replace(/['"]|UTF-8/g, ''))
            }
          }
          const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          })
          downloadBlob(blob, filename)
          this.$message.success('导出成功')
        }).catch(error => {
          console.error('导出失败:', error)
          this.$message.error('导出失败，请重试')
        }).finally(() => {
          loadingInstance.close()
        })
      })
    },
    relatedProjectChanged() {
      this.init()
      this.$emit("data-changed")
    },
    widthLevelChange(val) {
      setFrontSetting({ level: val }, this.dataId, "widthLevel")
    },
    dealFavorite() {
      if (this.sheetData.favoriteId) {
        deleteFavorite(this.sheetData.favoriteId).then(res => {
          this.init()
          this.$message.success("取消收藏成功")
        })
      } else {
        saveFavorite({
          appId: this.appId,
          dataId: this.dataId,
          description: "",
          sheetId: this.sheetData.sheetId
        }).then(res => {
          this.init()
          this.$nextTick(() => {
            this.$refs.favoriteInfo?.open(res)
          })
        })
      }
    },
    copyDataId() {
      copyToClipBoard(this.sheetData.id)
      this.$message.success("复制成功")
    },
    foldMemberInfo() {
      this.fold = !this.fold
      setFrontSetting({ fold: this.fold }, this.appId, "discuss")
      this.$nextTick(() => this.$refs.image?.resize())
    },
    refSearchData(filters) {
      this.refTableFilters = []
      this.refTableFilters = filters
    },
    dealLast() {
      if (this.unDealNumber > 200) {
        this.unDealNumber = this.unDealNumber - 200
        this.$refs.confirm.open()
        this.pageInfo.page = this.pageInfo.page + 1
      }
    },
    getCondition(page, size) {
      return {
        filters: this.refTableFilters,
        sheetId: this.refSheetDef.sheetId,
        dataIds: this.curTab.dataIds,
        page: page,
        size: size
      }
    },
    printRef() {
      this.from = "print"
      this.pageInfo = this.$options.data().pageInfo
      this.unDealNumber = this.curTab.dataIds.length
      this.$refs.selectPrintTemplateDialog.open({
        batchData: this.getCondition(this.pageInfo.page, this.pageInfo.size),
        sheetId: this.refSheetDef.sheetId,
        appId: this.appId
      })
    },
    nextBatch() {
      this.$nextTick(() => {
        this.$refs.selectPrintTemplateDialog.printEvent(
          this.getCondition(this.pageInfo.page, this.pageInfo.size)
        )
      })
    },
    fullChart() {
      this.$refs.fullChart.open(this.board, this.figure)
    },
    refreshChart() {
      this.active = true
      setTimeout(() => {
        this.active = false
      }, 1000)
      this.refreshBoard()
    },
    setFilter(from) {
      this.chartFrom = from
      this.chartFilterVisible = true
    },
    submitChartFilter() {
      if (this.chartFrom === "current") {
        this.$refs.image.init(this.figure)
      } else {
        this.$refs.fullChart.$refs.image.init(this.figure)
      }
      this.chartFilterVisible = false
      this.$message.success("操作成功")
    },
    closeChartFilter() {
      this.chartFilterVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-dialog {
  ::v-deep .el-dialog {
    width: calc(100vw - 100px) !important;
    height: calc(100vh - 70px) !important;
    min-width: 1200px;
    color: $color-font-first;

    .header {
      padding: 0 !important;

      .header-wrap {
        flex: auto;
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 20px;
        border-bottom: 2px solid #f5f5f5;

        .title {
          white-space: nowrap;
          margin-right: auto;
          font-size: $font-size-title-first;
          width: 500px;
          .icon-wrap {
            position: relative;
            top: 2px;
            font-size: 24px;
            line-height: 25px;
            vertical-align: middle;
            margin-right: 3px;
            color: $color-main;
          }
          .title-wrap {
            line-height: 25px;
            display: flex;
            .title-info {
              max-width: calc(100% - 90px);
            }
            .icon-trun-page {
              font-size: 16px;
              padding: 3px;
              color: $color-font-second;
              font-weight: bold;
              cursor: pointer;
              &:hover {
                color: $color-main;
              }
              &:first-of-type {
                padding-right: 0;
              }
              &:last-of-type {
                padding-left: 0;
              }
              &.is-disabled {
                color: $color-font-third;
                cursor: not-allowed;
              }
            }
          }
        }

        .button-warp {
          display: flex;

          & > * {
            margin-left: 8px;
          }
        }

        .operation-wrap {
          & > * {
            margin-left: 8px;
          }
          .svg-icon {
            font-size: 20px;
            color: #535c65;
            cursor: pointer;
          }
          .go {
            transform: rotate(360deg);
            transition: all 1s;
          }
        }
      }
    }

    .el-dialog__body {
      padding: 0 !important;
      margin: 0;
      flex: auto;
      display: flex;

      .body-wrap {
        flex: 1;
        display: flex;
        flex-flow: column;
        overflow: hidden;

        .sheet-info {
          display: flex;
          height: 100%;
          flex: 1;
          overflow: hidden;
          .data-info {
            flex: 1;
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column;
            .overview-info {
              margin: 10px 20px -4px 20px;
              flex: 0 0 auto;
            }
            .progress-info {
              margin: 10px 20px -4px 20px;
            }
            .content-wrap {
              position: relative;
              flex: 1;
              overflow: hidden;
              margin-left: 20px;
              .side-nav-wrap {
                margin-right: 20px;
                .sheet-menu {
                  .el-tabs__nav-wrap::after {
                    background-color: #f5f5f5;
                  }
                }
              }
              .content-box {
                display: flex;
                flex-flow: column;
                height: calc(100% - 54px);
                position: relative;
                .content-title {
                  margin: 6px 0 26px 56px;
                  position: relative;
                  line-height: 28px;

                  &:before {
                    content: "";
                    position: absolute;
                    left: -20px;
                    width: 6px;
                    height: 28px;
                    border-radius: 4px;
                    background-color: #1989fa;
                  }
                }

                .content-body {
                  display: flex;
                  flex-flow: column;
                  flex: auto;
                  box-sizing: border-box;
                  padding-right: 20px;
                  .sheet-table-wrap {
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-flow: column;
                    background-color: #fff;
                    &.full-screen {
                      padding: 0;
                      .operation {
                        padding: 10px 20px;
                        padding-left: 20px;
                      }
                    }
                    .operation {
                      display: flex;
                      margin-bottom: 6px;
                      position: relative;
                      z-index: 100;
                      .sheet-name {
                        margin-left: 20px;
                        margin-right: 20px;
                        position: relative;
                        line-height: 28px;
                        &:before {
                          content: "";
                          position: absolute;
                          left: -20px;
                          width: 6px;
                          height: 28px;
                          border-radius: 4px;
                          background-color: #1989fa;
                        }
                      }
                    }
                    .ref-button-group {
                      margin-left: auto;
                      span {
                        font-size: $font-size-main;
                        height: 28px;
                        line-height: 28px;
                        color: $color-main;
                        cursor: pointer;
                        &:hover {
                          color: #66b1ff;
                        }
                        & + span {
                          margin-left: 10px;
                        }
                      }
                    }
                    .sheet-table {
                      flex: auto;
                      overflow: hidden;
                    }
                  }
                  .chart-wrapper {
                    width: 100%;
                    display: flex;
                    flex-flow: column;
                    cursor: move;
                    border-radius: 4px;
                    border: 2px solid #f5f5f5;
                    margin-bottom: 20px;
                    box-sizing: border-box;
                    .full-board-title {
                      margin-top: 0;
                    }
                    &:hover {
                      .more-setting {
                        display: block !important;
                      }
                    }
                    .setting {
                      font-weight: bold;
                      font-size: 14px;
                      text-align: left;
                      padding: 20px 20px 0 10px;
                      height: 19.2px;
                      display: inline-table;
                      .more-setting {
                        display: none;
                        .wrapper {
                          display: flex;
                          align-items: center;
                          .refresh {
                            cursor: pointer;
                            margin-right: 6px;
                            font-size: 16px;
                          }
                          .button-active {
                            animation: rotate 1s infinite;
                            -webkit-animation: rotate 1s infinite;
                          }
                          @keyframes rotate {
                            0% {
                              transform: rotate(0deg);
                              -ms-transform: rotate(0deg); /* IE 9 */
                              -moz-transform: rotate(0deg); /* Firefox */
                              -o-transform: rotate(0deg);
                            }
                            100% {
                              transform: rotate(360deg);
                              -ms-transform: rotate(360deg); /* IE 9 */
                              -moz-transform: rotate(360deg); /* Firefox */
                              -o-transform: rotate(360deg);
                            }
                          }

                          @-webkit-keyframes rotate {
                            0% {
                              -moz-transform: rotate(0deg);
                            }
                            100% {
                              -moz-transform: rotate(360deg);
                            }
                          }
                          .full {
                            cursor: pointer;
                            margin-right: 6px;
                          }
                        }
                      }
                    }
                    .image {
                      overflow: hidden;
                      flex: 1;
                      position: relative;
                    }
                  }
                }
                .radio-group {
                  z-index: 10;
                  right: 20px;
                  top: -4px;
                  position: absolute;
                  .el-radio-button__inner {
                    padding: 4px 5px;
                  }
                  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
                    background-color: white;
                  }
                  .radio-icon {
                    height: 18px;
                    width: 18px;
                  }
                }
              }
            }
          }
          .member {
            background-color: #f5f7fa;
            position: relative;
            .fold {
              position: absolute;
              left: -20px;
              z-index: 10;
              cursor: pointer;
              color: #c0c4cc;
              &:hover {
                color: #1989fa;
              }
            }
          }
        }
      }
    }
  }
}
</style>
